import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import button from './button.js'
import tab from './tab.js'

export default contract({
  button: array([
    button
  ]),
  tab: array([
    tab
  ])
})